import { render, staticRenderFns } from "./TheHeaderDropdownHelp.vue?vue&type=template&id=50adabaa&scoped=true&"
import script from "./TheHeaderDropdownHelp.vue?vue&type=script&lang=js&"
export * from "./TheHeaderDropdownHelp.vue?vue&type=script&lang=js&"
import style0 from "./TheHeaderDropdownHelp.vue?vue&type=style&index=0&id=50adabaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50adabaa",
  null
  
)

export default component.exports